import { render } from "./DoughnutChart.vue?vue&type=template&id=71e8b41a&scoped=true"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"

import "./DoughnutChart.vue?vue&type=style&index=0&id=71e8b41a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e8b41a"]])

export default __exports__